import { Pipe, PipeTransform, TemplateRef } from '@angular/core';

@Pipe({
  name: 'isTemplateRef'
})
export class IsTemplateRefPipe implements PipeTransform {
  transform(value: unknown): boolean {
    return value instanceof TemplateRef;
  }
}
